import {en as tooltips} from "../tooltips";

export const casmon_english = {

    routes: {
        overview: 'Overview', // TODO - Übersetzung ergänzen
        reporting_root_page: "Reports",
        reporting_overview: "Report Overview",
        custom_reporting: "Custom Reports",
        events: "Events",
        reprocessing: "Reprocessing",
        integration: "Integrations",
        files: "Files",
        systems: 'Systems',
        alerting_mail: 'Alerting mail',
        mail_template: 'Mail template',
        data: 'Data',
        user: 'User',
        entities: 'Entities',
        access_control: 'Access Control',
        environment: 'Environment',
        settings: 'Settings',
        entity_types: 'Entity types',
        configuration: "Configuration",
        features_configuration: "Features Configuration"
    },
    configuration: {
        eventConfig: "Feature Configuration",
        eventConfig_paragraph: "Switch on/off the Features ",
        comment_button: 'Comment Process',
        info_button: 'Show additional information',
        mail_button: 'Send the link by email',
        restart_button: 'Restart Process',
        edit_button: "Edit",
        save_button: "Save",
        cancel_button: "Cancel",
    },

    header: {
        menu: "Menu",
        profile: 'Profile',
        signout: 'Sign out'
    },
    main_container: {
        modal_header: 'Session timed out',
        modal_content: 'Your session has expired. Please sign in again.',
        errorMessage: 'Could not load page.',
        login_button: 'Login'
    },

    language: "en",
    data_flow_graph: {
        node: {
            input: "In:",
            output: "Out:"
        },
        toolbar_menu: {
            filter_button: "Filter",
            from: "From:",
            to: "To:",
            since_prev_day: "Since previous day",
            rearrange_button: 'Auto layout',
            save_button: 'Save layout',
            auto_save: 'Auto save',
            save_success: 'Successfully saved',
            save_error: 'Error while saving'
        },
        properties: {
            contact_person_header: 'Contact person',
            information_header: 'Information',
            documentation: 'Documentation'
        },
        system_properties: {
            process: "Process",
            last_success: "Last success",
            last_failure: "Last failure",
            source: "Source",
            target: "Target",
            in: "In",
            out: "Out"
        },
        connection_properties: {
            process: "Process",
            source: "Source: ",
            target: " Target: ",
            in: " in ",
            runs_in: " executions in ",
            failed_runs_in: " errors in ",
            pending_runs_in: " warnings in ",
            processes: " processes; ",
            information_process: " process; "
        },
        connection_pop_up: {
            runs: "executions",
            errors: "Errors",
            warnings: "Warnings",
            last: "Last"
        },
        no_available_systems: "There are no systems available to show"
    },
    application_graph: {
        components: {
            sankey_chart: {
                process_instance_id: "Process Instance ID: ",
                start_at: 'Started on:',
                finished_at: 'Finished at: ',
                total_number_interface: 'Total number of interface executions:',
                active_interface: 'Active interface executions: ',
                errors_number: 'Number of mistakes:',
                faulty_process: 'Faulty processes: ',
                last_run: 'Last executed on: ',
                acute_process: 'Acute process',
                in_sumIn: 'In: ',
                out_sumOut: ' | Out: '
            },
            toolbar_menu: {
                menu_button: 'Since 5 p.m. the previous day', // TODO - Übersetzung ergänzen(seit 17 Uhr Vortag)
                filter_button: 'Filter',

            }
        }
    },
    common: {
        //simple_filter: "Simple filter",
        //detail_filter: "Detail filter",
        date_time_picker: {
            from: 'From',
            to: 'To',
            time_caption: "Time",
            date_format: 'MM/dd/yyyy - HH:mm',
            locale: 'en',
            false_input_format_text: "Input not in format: {{format}}",
            date_picker: {},
            time_picker: {
                hour: 'hours',
                minutes: 'minutes',
            }
        },
        process_mailer: {
            intro_text: 'Good day',
            msg_text_if: 'would you please look at the following process?',
            msg_text_else: 'can you take a look at the following process?',
            farewell_text_1: 'Thank you',
            farewell_text_2: 'Best regards'
        },
        dtoInterfaces: {
            systemDtoI: {
                System_manager: "System manager",
                Developer: "Developer",
                Administration: "Administration",
                Hotline: "Hotline",
                BusinessConsultant: "Business consultant",
                Business: "Business"
            }
        },
        contact_person_list: {
            employee: "Employee",
            contact_details: "Contact details",
            further_information: "Further information"
        },
        toolbar: {
            filter_options: "Further filter options"
        },
        date_time_formats: {
            date_time: "MM/DD/yyyy HH:mm:ss.SSS",
            date: "MM/DD/yyyy",
            time: "HH:mm:ss.SSS"
        },
        input_dropdown_accordion: {
            add_item_button: "+ Item"
        }
    },
    events: {
        shared_resources: {
            comment_section: {
                conditional_wrapper: 'Show comment.',
                header: 'Number of comments:',
                form_placeholder: "Write a comment ...",
                send_button: 'Send',
                switch_to_unit_of_work: 'Switch to Unit of Work.',
                comment: {
                    unknown_user: "Unknown User",
                }
            },
            comment_button: {
                hide_comment: 'Hide comment',
                show_comment: 'Show comment'
            },
            additional_information: {
                hint: 'Show additional information',
                toast_error: "No additional information could be loaded.",
                modal: {
                    header: "Additional information",
                    contact_person_header: "Contact person",
                },
                integration_table: {
                    source: "Source",
                    target: "Target",
                    link: "Link",
                    comment: "Comment",
                }
            }
        },
        details: {
            msg_header: 'Semantic',
            raw_data_item: 'Raw data'
        },
        filter_toolbar: {
            processes: "Processes",
            unitsOfWork: "Units Of Work",
            checkbox_error: 'Error',
            checkbox_warning: 'Warning',
            checkbox_successful: 'Successful',
            checkbox_partial_hits: 'Include partial hits',
            checkbox_partial_hits_warning: 'May limit performance',

            detail_filter: {
                contents: "Contents",
                contents_placeholder: "Semantic field",
                process: {
                    process: "Process",
                    source: "Source",
                    target: "Target",
                    processId: "ProcessId",
                    message: "Message",
                },
                unitOfWork: {
                    application: "Application",
                    mandant: "Mandant",
                    function: "Function"
                }
            }
        },
        process: {
            toast_upload: 'Upload was successful.',
            table_end: 'END:',
            table_start: 'START:',
            popup_content: 'Share process via email',
            unknown: 'Unknown'
        },
        process_list: {
            loader_text: "Loading...",
            toast_error: "An error has occurred.",
            placeholder_text: "There are no results for your search.",
            time_header: 'Date',
            source_header: 'Source',
            target_header: 'Target',
            name_header: 'Name',
            duration_header: 'Duration',
            link_header: 'Link to process'
        },
        reprocess: {
            notConfigured: 'Reprocessing for this process type is not configured!'
        },
        unit_of_work: {
            table_end: 'END:',
            table_start: 'START:',
            table_duration: 'DURATION',
            unknown: 'Unknown'
        },
        reprocess_modal: {
            header: "Reprocessing",
            error_header: "Error",
            description: "The reprocessing will soon be started. Enter an additional comment!",
            comment_placeholder: "Comment",
            cancel_button: "Cancel",
            close_button: "Close",
            start_reprocessing_button: "Start reprocessing",
            start: "Reprocessing is starting!",
            done: "Reprocessing started!",
            error_text: "The operation could not be performed.",
        }
    },
    reporting: {
        process_list_report: {
            loader_text: "Loading...",
            placeholder_text: "There are no results for your search.",
            time_header: 'Date',
            source_header: 'Source',
            target_header: 'Target',
            name_header: 'Name',
            duration_header: 'Duration',
            link_header: 'Link to process'
        },
        ProcessOverviewReport: {
            header_last: 'Last 10 Process',
            header_last_errors: 'Last 10 Process with Errors'
        },
        statistic: {
            unknown : "Unknown",
            placeholder_text: "There are no results for your search.",
            source_header: 'Source',
            target_header: 'Target',
            process_name: 'Process name',
            count_header: 'Number',
            count_errors: 'Number of errors',
            count_warnings: 'Number of warnings',
            error_rate: 'Error rate',
            min_duration: 'Min duration',
            max_duration: 'Max duration',
            min_duration_error: 'Min duration(error)',
            max_duration_error: 'Max duration(error)',
            avg_duration: 'Avg duration'

        }
    },
    reprocessing: {
        filter_toolbar: {
            source_placeholder: "Source",
            target_placeholder: "Target",
            processname_placeholder: "Process name",
            application_placeholder: "Application",
            function_placeholder: "Function",
            mandant_placeholder: "Mandant",
            errormessage_placeholder: "Error message",
            select_all_processes_checkbox: "Select all processes",
            start_mass_reprocessing_button: "Start mass reprocessing",
            detail_view_toggle: "Detailed view",
        },
        progress_modal: {
            header: "Mass reprocessing is executed",
            success_state: "The reprocessing was successfully started.",
            error_state: "Reprocessing has begun. However, errors have occurred.",
            progress_state: "{{value}} of {{length}} reprocessings were started.",
            close_button: "Close",
        },
        error_modal: {
            header: "Mass processing could not be performed",
            description: "No process or unit of work was selected for reprocessing."
        }
    },
    tooltips: tooltips
};

